export default "__VITE_ASSET__COBRGW7m__"